var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpClothActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#006EFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M773.2,742.8l-192,448l-10.4,24.3c-95.9-2.5-191.5-10.3-286.5-23.3l-19.9-4.3c-8.6-1.9-14.1-10.4-12.3-19 c0.1-0.2,0.1-0.5,0.2-0.7L407.6,576h464.8L906,704H795.1c-3.2,0-6.1,1.9-7.3,4.8L773.2,742.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1116.2,163.2L877.8,66.3c-3.8-1.5-7.9-2.3-12-2.3H755.5c-6.9,0-13,4.4-15.2,10.9L736,88 c-10.9,42.4-52.2,72-96,72s-85.1-29.6-96-72l-4.3-13.1c-2.2-6.5-8.3-10.9-15.2-10.9H414.2c-4.1,0-8.2,0.8-12,2.3l-238.4,96.9 c-6.9,2.8-11,10-9.8,17.4l35.8,222c1.3,7.8,8,13.4,15.8,13.4H384l24,96h464l24-96h178.4c7.9,0,14.5-5.7,15.8-13.5l35.8-222 C1127.1,173.2,1123.1,166,1116.2,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M829.9,772.8l-185.1,432c-1.7,4.1,0.1,8.8,4.2,10.5c1,0.4,2.1,0.6,3.1,0.6H736l184-136h-32l-110.7,39.5 L880,880l144,336h83.9c4.4,0,8-3.6,8-8c0-1.1-0.2-2.2-0.6-3.1l-185.1-432c-1.3-2.9-4.2-4.9-7.4-4.8h-85.4 C834.1,768,831.2,769.9,829.9,772.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1160,832h48c4.4,0,8,3.6,8,8v368c0,4.4-3.6,8-8,8h-48c-4.4,0-8-3.6-8-8V840C1152,835.6,1155.6,832,1160,832z "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpClothActive);
export default __webpack_public_path__ + "static/media/hp_cloth_active.7c0e8e782cde68782c8b1ca0a2ed8656.svg";
export { ForwardRef as ReactComponent };